
// Formats a numeric value as a currency string with the given symbol.
// Negative values are wrapped in parentheses, e.g. "($ -10.00)".
export const getMoneyColumnVal = (symbol = "", val = 0) => {
    const money = `${symbol}${val.toFixed(2)}`;
    return val < 0 ? `(${money})` : money;
};

// Formats a number as a US locale currency string with exactly 2 decimal places.
// e.g. 1234.5 → "1,234.50"
export const getCurrencyToLocaleString = (amount) => {
    return Number(amount).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

// Converts a value to a string fixed to 2 decimal places.
// e.g. 3.1 → "3.10"
export const getNumStrWithTwoDecimals = (val) => {
    return Number.parseFloat(val).toFixed(2);
};
